module.exports = __webpack_public_path__ + "img/activity-time-calendar.bb0427c8.svg";